// Инициализация всех секций с миссией на странице
const initMissionSections = () => {
  const sections = document.querySelectorAll('.our-mission-sec');

  sections.forEach((section) => {
    const images = section.querySelectorAll('.our-mission-sec__image');
    const items = section.querySelectorAll('.our-mission-sec__item');

    // Проверка наличия элементов списка
    if (!items.length) return;

    let activeIndex = 0;
    const hasImages = images.length > 0;

    const prevArrows = section.querySelectorAll('.swiper-button-prev');
    const nextArrows = section.querySelectorAll('.swiper-button-next');

    /**
     * Обновляет высоту активного элемента
     * @param {number} index - индекс активного элемента
     */
    const updateHeight = (index) => {
      const activeItem = items[index];
      if (!activeItem) return;

      activeItem.classList.add('active');

      const itemBody = activeItem.querySelector('.our-mission-sec__item-body');
      if (itemBody) {
        itemBody.style.maxHeight = `${itemBody.scrollHeight + 80}px`;
      }
    };

    /**
     * Обновляет состояние секции (активные элементы и изображения)
     * @param {number} index - индекс нового активного элемента
     */
    const updateState = (index) => {
      // Сброс всех элементов
      items.forEach((item) => {
        item.classList.remove('active');
        const body = item.querySelector('.our-mission-sec__item-body');
        if (body) body.style.maxHeight = null;
      });

      // Сброс изображений (только если они есть)
      if (hasImages) {
        images.forEach((img) => {
          img.classList.remove('active');
          img.style.display = 'none';
          img.style.opacity = '0';
        });
      }

      // Активация текущего элемента
      updateHeight(index);

      // Активация текущего изображения (только если изображения присутствуют)
      if (hasImages && images[index]) {
        const activeImage = images[index];
        activeImage.style.display = 'block';

        requestAnimationFrame(() => {
          activeImage.style.opacity = '1';
          activeImage.classList.add('active');
        });
      }

      // Обновление состояния стрелок навигации
      prevArrows.forEach((arrow) => {
        arrow.classList.toggle('disabled', index === 0);
      });

      nextArrows.forEach((arrow) => {
        arrow.classList.toggle('disabled', index === items.length - 1);
      });
    };

    // Инициализация начального состояния
    updateState(activeIndex);

    // Обработчики кликов на элементах списка
    items.forEach((item, index) => {
      const itemNav = item.querySelector('.our-mission-sec__item-nav');
      if (!itemNav) return;

      itemNav.addEventListener('click', () => {
        if (index === activeIndex) return;
        activeIndex = index;
        updateState(activeIndex);
      });
    });

    // Обработчики кликов на стрелках "назад"
    prevArrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        if (activeIndex > 0) {
          activeIndex--;
          updateState(activeIndex);
        }
      });
    });

    // Обработчики кликов на стрелках "вперед"
    nextArrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        if (activeIndex < items.length - 1) {
          activeIndex++;
          updateState(activeIndex);
        }
      });
    });

    // Обработчик изменения размера окна (с debounce для оптимизации)
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateHeight(activeIndex);
      }, 100);
    };

    window.addEventListener('resize', handleResize);
  });
};

// Инициализация после загрузки DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMissionSections);
} else {
  initMissionSections();
}